<template>
  <PageWrap page-title="Incidencias">
    <b-row class="mb-4">
      <b-col md="5" lg="4" xl="3">
        <BfInput
          :value="filter.textSearch"
          label="Búsqueda"
          data-key="textSearch"
          placeholder="Buscar por número de encargo"
          suffix-icon="el-icon-search"
          :bottom-gutter="false"
          @update="updatePageFilter"
        />
      </b-col>

      <b-col class="d-flex">
        <BfCheckbox
          :value="showPendientes"
          label="Pendientes"
          data-key="showPendientes"
          :bottom-gutter="false"
          ft
          class="mr-5"
          @update="showIncidencesPendient"
        />
        <BfCheckbox
          :value="filter.showResueltas"
          label="Resueltas"
          data-key="showResueltas"
          :bottom-gutter="false"
          ft
          class="mr-5"
          @update="updatePageFilter"
        />
        <BfCheckbox
          :value="filter.showNotificadas"
          label="Notificadas"
          data-key="showNotificadas"
          :bottom-gutter="false"
          @update="updatePageFilter"
        />
      </b-col>
    </b-row>

    <LoadingIndicator v-if="loadingData" />

    <BfTable
      v-else
      :data="incidencias"
      :columns="tableColumns"
      cell-class-name="tasaciones-small-cell"
      stripe
      :row-class-name="tableRowClassNames"
      @row-click="tableRowClick"
    >
      <template
        slot="notificada_texto"
        slot-scope="{row}"
      >{{row.notificada_texto ? "SI" : "Notificar"}}</template>

      <span
        slot="encargos_numero"
        slot-scope="{row}"
        class="tasaciones-table-marker"
      >{{row.encargos_numero}}</span>
      <span
        slot="encargos_codigo"
        slot-scope="{row}"
        class="tasaciones-table-marker"
      >{{row.encargos_codigo}}</span>
    </BfTable>
  </PageWrap>
</template>

<script>
import qsBinder from '@holamundo.app/vue-router-qs-binder';
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { incidentAPI } from '@/api';
import { debounce, get } from '@/utils';

const FILTER_PROPERTIES = {
  textSearch: undefined,
  showNotificadas: undefined,
  showResueltas: undefined,
  encargos_codigo: undefined,
};

export default {
  name: 'IncidentsList',

  mixins: [
    qsBinder({
      dataKey: 'filter',
      data: ({ query }) =>
        Object.keys(FILTER_PROPERTIES).reduce((acc, key) => {
          const value = get(query, [key], FILTER_PROPERTIES[key]);

          const formattedValue = () => {
            switch (key) {
              case 'showNotificadas':
              case 'showResueltas':
                return typeof value === 'string' ? value === 'true' : value;
              default:
                return value;
            }
          };

          return {
            ...acc,
            [key]: formattedValue(),
          };
        }, {}),
      didUpdate: ($this) => {
        $this.loadData();
      },
    }),
  ],

  props: {
    chargeNumber: {
      type: [Number, String],
    },
  },

  data() {
    return {
      loadingData: false,
      incidencias: [],
      showPendientes: true,
    };
  },

  created() {
    if (this.chargeNumber && this.filter.textSearch !== this.chargeNumber) {
      this.updateQsData({
        textSearch: this.chargeNumber,
      });
    } else {
      this.loadDataPendient();
    }
  },

  methods: {
    showIncidencesPendient() {
      if (this.showPendientes) {
        this.showPendientes = false;
        this.loadData();
      } else {
        this.showPendientes = true;
        this.filter.showResueltas = false;
        this.filter.showNotificadas = false;
        console.log('cargando en teoria las buenas');
        this.loadDataPendient();
      }
    },
    async loadData() {
      this.loadingData = true;
      try {
        const { data } = await incidentAPI.getAll({
          search: this.filter.textSearch,
          completas: this.filter.showResueltas ? 1 : '',
          notificada: this.filter.showNotificadas ? 1 : '',
          // sort: '-encargos_codigo',
        });
        this.incidencias = data.reverse();
      } catch ({ message = '' }) {
        this.$bfNotify({
          type: 'error',
          title: 'Error',
          message,
        });
      } finally {
        this.loadingData = false;
      }
    },
    async loadDataPendient() {
      this.loadingData = true;
      try {
        const { data } = await incidentAPI.getAll({
          search: this.filter.textSearch,
          completas: 0,
          notificada: this.filter.showNotificadas ? 1 : '',
          // sort: '-encargos_codigo',

        });
        this.incidencias = data.reverse();
      } catch ({ message = '' }) {
        this.$bfNotify({
          type: 'error',
          title: 'Error',
          message,
        });
      } finally {
        this.loadingData = false;
      }
    },

    /* eslint-disable-next-line func-names */
    updatePageFilter: debounce(function({ key, value }) {
      this.showPendientes = false;
      this.updateQsData({
        [key]: value,
      });
    }, 350),

    tableRowClick({ row, column }) {
      if (column.property === 'encargos_codigo') {
        router.push({ name: 'incidencia', params: { id: `${row.id}` } });
      }

      if (column.property === 'encargos_numero') {
        router.push({ name: 'charge', params: { id: `${row.encargos_id}` } });
      }

      if (column.property === 'notificada_texto') {
        if (!row.notificada_texto) {
          console.log(row.id);
          this.setNotificada(row.id);
          this.loadData();
        }
      }
    },
    async setNotificada(id) {
      const newData = { notificada: true };

      try {
        const { message } = await incidentAPI.update({
          id,
          data: newData,
        });

        this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
      } catch ({ errors }) {
        this.$bfNotify({
          title: 'Error',
          message: 'Existe un error con tus datos',
          type: 'error',
        });
      }
    },
    sortTable() {
      this.loadData();
    },
    tableRowClassNames({ row }) {
      const classNames = [];

      if (row.inactivo === true) {
        classNames.push('inactivo-row');
      }

      return classNames.join(' ');
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          label: 'Cod',
          dataKey: 'encargos_codigo',
          sortable: true,
          width: 72,
        },
        {
          label: 'Cli',
          dataKey: 'encargos_empresa_cliente_nombre',
          sortable: true,
          width: 50,
        },
        {
          label: 'Nº Encargo',
          dataKey: 'encargos_numero',
          sortable: true,
          width: 90,
        },

        {
          label: 'Tipo',
          dataKey: 'tipo',
          sortable: true,
          width: 220,
        },
        {
          label: 'Descripción',
          dataKey: 'descripcion',
          sortable: true,
        },
        {
          label: 'Tas Enc',
          dataKey: 'tasador_encargado_nombre',
          sortable: true,
          width: 50,
        },
        {
          label: 'Creada',
          dataKey: 'creada_texto',
          sortable: true,
          width: 90,
        },
        {
          label: 'Notif',
          dataKey: 'notificada_texto',
          sortable: true,
          width: 50,
          align: 'center',
        },
        {
          label: 'Resu',
          dataKey: 'resuelta_texto',
          sortable: true,
          width: 50,
        },
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>

<style>
.inactivo-row td {
  background-color: rgba(212, 149, 40, 0.49);
}
</style>
